import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState } from 'react';
import { Input } from '../Input';
import { Button } from '../../subkit-ui';
import { Information } from '../Information';
import { validateEmail } from '../../utils/helpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ModalLoginForm = function ModalLoginForm(_ref) {
  var onSubmit = _ref.onSubmit,
      loading = _ref.loading,
      title = _ref.title,
      buttonText = _ref.buttonText;

  var _useState = useState({
    email: ''
  }),
      formData = _useState[0],
      setFormData = _useState[1];

  var _useState2 = useState(false),
      isValid = _useState2[0],
      setIsValid = _useState2[1];

  var isDisabled = !isValid || loading;

  var onSubmitHandler = function onSubmitHandler(event) {
    event.preventDefault();

    if (!isValid) {
      return;
    }

    if (onSubmit) {
      onSubmit(formData);
    }
  };

  var onChange = function onChange(name, value) {
    var nextFormData = _objectSpread(_objectSpread({}, formData), {}, _defineProperty({}, name, value));

    setFormData(nextFormData);
    updateValidity(nextFormData);
  };

  var updateValidity = function updateValidity(data) {
    setIsValid(validateEmail(data.email));
  };

  return /*#__PURE__*/_jsxs("form", {
    onSubmit: onSubmitHandler,
    "data-cy": "ModalLoginForm",
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex justify-center mb3",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex flex-column items-center",
        children: [/*#__PURE__*/_jsx("img", {
          src: "https://subkit-images.s3.amazonaws.com/subkit-logos-images/favicon.ico",
          alt: "Subkit Logo",
          className: 'h-auto clickable my1 nav-brand',
          style: {
            width: 40
          }
        }), /*#__PURE__*/_jsx(Information, {
          heading: title,
          styles: {
            heading: 'text-2xl'
          }
        })]
      })
    }), /*#__PURE__*/_jsx(Input, {
      format: "rounded",
      label: "Email address",
      placeholder: "Email address",
      classes: {
        container: 'mb2',
        input: 'col-12'
      },
      name: "email",
      inputValue: formData.email,
      onInputChange: onChange,
      dataCy: "user-email-address"
    }), /*#__PURE__*/_jsx(Button, {
      buttonType: "submit",
      classes: "my-5 w-full",
      text: buttonText,
      disabled: isDisabled
    })]
  });
};